<template>
	<sa-page-layout :btnSaveVisible="btnSaveVisible" :btnAnnullaVisible="true" :linkback="linkback" :pathResource="pathResource" :data="jsonData" :showModalLoading="showModalLoading" class="sa-no-space">
		<template slot="table-body">
			<gestione-attivita-tasks-edit-component @updateJsonData="onUpdateJsonData"></gestione-attivita-tasks-edit-component>
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/layout/components/SaPageLayout.vue";
import GestioneAttivitaTasksEditComponent from "../components/GestioneAttivitaTasksEditComponent.vue";
export default {
	components: { GestioneAttivitaTasksEditComponent, SaPageLayout },
	data() {
		return {
			btnSaveVisible: true,
			showModalLoading: false,
			linkback: "/gestioneattivita/tasks",
			pathResource: "/gestioneattivitatasks",
			jsonData: null,
		};
	},
	methods: {
		onUpdateJsonData(jsonData) {
			this.jsonData = jsonData;
		},
	},
};
</script>

<style></style>
